module.exports = __webpack_public_path__ + "img/picto-events.4d9d2f54.svg";